export const menu = {
  menu_title: 'Resonance',
  menu_logOut: 'تسجيل الخروج',
  menu_language_button_text: 'تغيير',
  menu_languages_modal_title: 'اختر لغتك',
  menu_questionnaires_modal_title: 'اختر استبيانًا'
};
